<template>
    <div class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <!-- Sidebar Component -->
      <Sidebar 
        :sidebar-open="sidebarOpen" 
        @toggle-sidebar="toggleSidebar"
        @navigate="handleNavigation"
      />
  
      <!-- Main Content loArea -->
      <div class="lg:pl-64 flex flex-col min-h-screen">
        <!-- Top Navbar Component -->
        <Navbar @toggle-sidebar="toggleSidebar" />
        
        <!-- Main Content Component -->
        <div class="flex-1">
          <slot></slot>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
import Sidebar from './components/Sidebar.vue';
import Navbar from './components/Navbar.vue';





  
  
  
  const sidebarOpen = ref(false)
  
  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value
  }
  
  const handleNavigation = (itemName) => {
    console.log('Navigating to:', itemName)
    
    if (window.innerWidth < 1024) {
      sidebarOpen.value = false
    }
  }
  </script>